module.exports = __webpack_public_path__ + "static/img/rank_345.ad8df0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_345.png
// module id = C6l3
// module chunks = 0